import React, {useEffect, useRef, useState} from 'react'
import {bindActionCreators} from "redux";
import * as actions from "./EmployeesPageActions";
import {connect} from "react-redux";
import {humanize, trimAndCollapse} from '../../utilities';
import {
    Button,
    Checkbox,
    Col,
    ControlLabel,
    FormControl,
    FormGroup,
    Grid,
    InputGroup,
    Modal,
    Nav,
    NavItem,
    OverlayTrigger,
    Row,
    Tab,
    Tabs,
    Tooltip
} from "react-bootstrap";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import {defaultDateFormat, isEmailValid, rolesDescriptions, select} from "../../common/commonHandlers";
import Helmet from "react-helmet";
import PageHeader from "../../components/PageTitle";
import {addAlert} from "../App/actions";
import * as EmployeeActions from "../../actions/employees";
import Select from "react-select";
import Dropzone from "react-dropzone";
import Attachment from "../../components/image/Attachment";
import {setAsPrimary, uploadImages, validateUser} from "../ClientsPage/tabs/Users/UsersListApi"
import _ from 'lodash'
import {SketchPicker} from "react-color";
import "./EmployeesPage.scss"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEye, faEyeSlash} from "@fortawesome/free-solid-svg-icons";
import InputGroupAddon from "react-bootstrap/lib/InputGroupAddon";
import {checkUniqueEmail} from "../RegisterPage/RegisterPageApi"
import MDSpinner from "react-md-spinner";
import SignatureModal from "./SignatureModal";
import Dollars from "../../components/Dollars";
import ColorCheckbox from '../Scheduler/ColorCheckbox';
import {useMediaQuery} from '../../utilities/hooks/useMediaQuery';

const Actions = {
    ...actions,
    addAlert,
    ...EmployeeActions,
    uploadImages,
    setAsPrimary,
    validateUser,
    checkUniqueEmail,
}

const employeesSortOptions = [
    {value: 'NAZ', label: 'First name A-Z'},
    {value: 'NZA', label: 'First name Z-A'},
    {value: 'LAZ', label: 'Last name A-Z'},
    {value: 'LZA', label: 'Last name Z-A'},
    {value: 'JAZ', label: 'Job title A-Z'},
    {value: 'JZA', label: 'Job title Z-A'}
]

const EmployeesPage = ({
                           actions,
                           employee,
                           employeeList,
                           editingEmployeeId,
                           filterText,
                           employeeListLastUpdated, auth
                       }) => {
    const isMobile = useMediaQuery(991);
    const smMobile = useMediaQuery(450);
    const [sortType, setSortType] = useState(employeesSortOptions[0])
    const [key, setKey] = useState(1);
    const [settings, setSettings] = useState({sort_type: "NAZ", key: 1})
    const [subscriptionSettings, setSubscriptionSettings] = useState({})
    const [loading, setLoading] = useState(true)
    const [searchValue, setSearchValue] = useState('')
    const [employeesRedirectList, setEmployeesRedirectList] = useState([])
    const [roles, setRoles] = useState([])
    const [oldEmployee, setOldEmployee] = useState(undefined)
    const [showPicker, setShowPicker] = useState(false)
    const [errorMessage, setErrorMessage] = useState({})
    const [showSubscriptionModal, setShowSubscriptionModal] = useState()
    const [showPassword, setShowPassword] = useState(false)
    const [signatureModal, setSignatureModal] = useState({show: false, text: ""})
    const [showCompanyName, setShowCompanyName] = useState(false)
    const [employeeRoles, setEmployeeRoles] = useState([])
    const pickerRef = useRef(null);
    const formRef = useRef(null);
    const linkedUserId = employee?.user?.id || (oldEmployee?.id === employee?.id && oldEmployee?.user?.id)
    const isExistingEmployeeWithoutUser = employee?.id > 0 && !linkedUserId
    const addsActiveUser = !isExistingEmployeeWithoutUser && !employee?.disabled &&
        (!employee?.user?.id || oldEmployee?.is_user_disabled)

    const show = () => {
        setSignatureModal({show: true, text: employee?.signature || employee?.user?.signature || ""})
    }

    useEffect(() => {
        if (oldEmployee) {
            const merged = _.merge({..._.omitBy(employee, _.isNull)}, {..._.omitBy(oldEmployee, _.isNull)})
            actions.updateEmployee(merged.id, merged)
        }
    }, [oldEmployee])

    useEffect(() => {
        if (!loading) {
            const subcontractorRole = key === 2 ? [7] : []
            setEmployeeRoles(employee?.user?.roles || subcontractorRole)
        }
    }, [employee]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (pickerRef.current && !pickerRef.current.contains(event.target)) {
                setShowPicker(false)
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [pickerRef]);

    const refreshEmployeeList = () => {
        actions.fetchEmployeeList()
        editEmployee(null)
    }

    const validation = () => {
        let is_valid = true;
        let newErrors = {};
        const requiredErrorMessage = "This field is required!";
        if (employee?.first_name?.length === 0) {
            newErrors = {...newErrors, first_name: requiredErrorMessage}
            is_valid = false
        }
        if (employee?.last_name?.length === 0) {
            newErrors = {...newErrors, last_name: requiredErrorMessage}
            is_valid = false
        }
        if (employee?.email_address?.length === 0) {
            newErrors = {...newErrors, email_address: requiredErrorMessage}
            is_valid = false
        }
        const phone_number = employee.phone_number && employee.phone_number.replace(/\D/g, "")
        if (phone_number && phone_number.length > 0 && phone_number.length !== 10) {
            newErrors = {...newErrors, phone_number: "Phone number must be 10 digits long"}
            is_valid = false
        }
        if (employee?.email_address?.length > 0 && !isEmailValid(employee?.email_address)) {
            newErrors = {...newErrors, email_address: "Email address incorrect"}
            is_valid = false
        }
        if (employee?.job_title?.length === 0) {
            newErrors = {...newErrors, job_title: requiredErrorMessage}
            is_valid = false
        } else if (employee?.job_title?.length > 40) {
            newErrors = {...newErrors, job_title: "Job title can't be longer than 40 characters"}
            is_valid = false
        }
        if (employee?.id > 0) {
            if (employee?.user?.password?.length > 0 || employee?.user?.password_confirmation?.length > 0) {
                if (employee?.user?.password.length < 6) {
                    newErrors = {...newErrors, password: "Passwords must be at least 6 characters"}
                    is_valid = false
                } else if (employee?.user?.password !== employee?.user?.password_confirmation) {
                    newErrors = {...newErrors, password: "Passwords don't match!"}
                    is_valid = false
                }
            }
        } else {
            if (employee?.user?.password.length < 6) {
                newErrors = {...newErrors, password: "Passwords must be at least 6 characters"}
                is_valid = false
            } else if (employee?.user?.password !== employee?.user?.password_confirmation) {
                newErrors = {...newErrors, password: "Passwords don't match!"}
                is_valid = false
            }
        }
        if (employeeList && employeeList.length > 0 && employeeList.some(e => e.color?.toUpperCase() === employee?.color?.toUpperCase() && e.id !== employee?.id)) {
            newErrors = {...newErrors, color: "Another user has already been assigned this color"}
            is_valid = false
        }
        if (addsActiveUser && subscriptionSettings.max_user_count <= subscriptionSettings.active_users && !subscriptionSettings.permanent_subscription) {
            newErrors = {...newErrors, first_name: 'Max number of user is used.'}
            is_valid = false
        }
        return newErrors
    }

    const saveWithSubscriptionCheck = callback => {
        if (addsActiveUser && subscriptionSettings.active_users >= subscriptionSettings.stripe_subscription.user_count && !subscriptionSettings.permanent_subscription) {
            setLoading(false)
            setShowSubscriptionModal({callback})
        } else {
            callback()
        }
    }

    const submitForm = (e, id) => {
        e.preventDefault()
        if (loading) return

        const validationErrors = validation()
        const hasValidationErrors = Object.keys(validationErrors).length > 0

        if (isExistingEmployeeWithoutUser) {
            setErrorMessage(validationErrors)
            if (hasValidationErrors) return
            setLoading(true)
            actions.saveOrCreateEmployee(id, res => actions.loadEmployeeForEditing(res.id, savedEmployee => {
                actions.fetchEmployeeList()
                setErrorMessage({})
                setOldEmployee(savedEmployee)
                setLoading(false)
            }))
            return
        }

        setLoading(true)

        actions.checkUniqueEmail(employee?.email_address, employee?.user?.id, true, res => {
            const combined = {...validationErrors}
            if (!res.unique) {
                combined.email_address = "Email address already exists"
            }
            setErrorMessage(combined)

            if (!res.unique || hasValidationErrors) {
                setLoading(false)
                return
            }

            saveWithSubscriptionCheck(increaseSubscription =>
                actions.saveOrCreateEmployee(id, savedEmployee =>
                    actions.saveUserInfo({
                        ...employee.user,
                        person_id: savedEmployee.person_id,
                        email: employee.email_address,
                        disabled: employee.disabled,
                        isSubcontractor: key === 2,
                        signature: employee.signature,
                    }, savedRes => {
                        if (auth?.user_id === employee?.user?.id) {
                            const newRoles = roles.filter(r => savedRes.roles.includes(r.id)).map(r => r.code)
                            actions.updateRolesInState(newRoles)
                        }
                        const finishSaving = () => {
                            if (addsActiveUser) refreshSubscriptionSettings()
                            actions.loadEmployeeForEditing(savedRes?.employee_id, loaded => {
                                actions.fetchEmployeeList()
                                setErrorMessage({})
                                setOldEmployee(loaded)
                                setLoading(false)
                            })
                        }
                        if (increaseSubscription) {
                            actions.updateSubscription({
                                ...subscriptionSettings.stripe_subscription,
                                user_count: Number(subscriptionSettings.stripe_subscription.user_count) + 1
                            }, finishSaving, () => setLoading(false))
                            return
                        }
                        if (oldEmployee && !oldEmployee.disabled && employee.disabled && !employee.is_user_disabled) {
                            actions.updateSubscription({
                                ...subscriptionSettings.stripe_subscription,
                                user_count: Number(subscriptionSettings.stripe_subscription.user_count) - 1
                            }, refreshSubscriptionSettings)
                        }
                        finishSaving()
                    }, () => setLoading(false))
                )
            )
        })
    }

    const editEmployee = employeeId => {
        setErrorMessage({})
        actions.loadEmployeeForEditing(employeeId, res => setOldEmployee(JSON.parse(JSON.stringify(res))))
    }

    const addNewEmployee = () => {
        setOldEmployee(undefined)
        actions.createNewEmployee()
        editEmployee(0)
    }

    const deleteEmployee = id => {
        actions.deleteEmployee(id, () => {
            actions.fetchEmployeeList() //refresh the list
            editEmployee(null)
        })
    }

    const changeFilterText = txt => {
        setSearchValue(txt)
        editEmployee(null)
    }

    const renderTextField = (employee, attr, require = false) => {
        const name = humanize(attr)
        return (
            <FormGroup key={attr}>
                <ControlLabel>
                    {name}{require && "*"}
                </ControlLabel>
                <FormControl
                    type="text"
                    className="require-field"
                    placeholder={name}
                    value={employee[attr] || ""}
                    onChange={e => {
                        actions.updateEmployeeAttribute(
                            employee.id,
                            attr,
                            e.target.value
                        )
                    }}
                    onBlur={e => {
                        actions.updateEmployeeAttribute(
                            employee.id,
                            attr,
                            trimAndCollapse(e.target.value)
                        )
                    }}
                />
                {errorMessage && errorMessage[attr] && <p className="error-message">{errorMessage[attr]}</p>}
            </FormGroup>
        )
    }

    const renderPhoneField = (employee, attr) => {
        const name = humanize(attr)
        const handlePhoneBlur = (e) => {
            const value = trimAndCollapse(e.target.value)
            actions.updateEmployeeAttribute(employee.id, attr, value)
            const digits = value.replace(/\D/g, "")
            if (digits.length > 0 && digits.length !== 10) {
                setErrorMessage({...errorMessage, phone_number: "Phone number must be 10 digits long"})
            } else {
                const { phone_number, ...rest } = errorMessage;
                setErrorMessage(rest);
            }
        }
        return (
            <FormGroup key={attr} bsStyle={errorMessage[attr] ? 'error' : null}>
                <ControlLabel>
                    {name}
                </ControlLabel>
                <FormControl
                    type="text"
                    className="require-field"
                    placeholder={name}
                    value={employee[attr] || ""}
                    onChange={e => {
                        actions.updateEmployeeAttribute(
                            employee.id,
                            attr,
                            e.target.value
                        )
                    }}
                    onBlur={handlePhoneBlur}
                />
                {errorMessage && errorMessage[attr] && <p className="error-message">{errorMessage[attr]}</p>}
            </FormGroup>
        )
    }

    const handleDateChange = (e, attr) => {
        if (typeof e === 'string' || e instanceof String) {
            const validFormat = moment(e).format(defaultDateFormat) === e
            if (e.length > 10) {
                employee[attr] = 'Invalid Date';
            } else if (e.length === 10 && !validFormat) {
                employee[attr] = 'Invalid Format';
            }
        } else {
            employee[attr] = (e && e !== '') ? e : null;
        }
        actions.updateEmployeeAttribute(employee.id, attr, employee[attr])
    };

    const filterAndSortEmployeeList = employees => {
        let selectedEmployees = []

        if (employees?.length > 0) {
            employees.map(e => {
                selectedEmployees.push({
                    ...e,
                    name: `${e.company_name && key === 2 && showCompanyName ? `${e.company_name}, ` : ''}${e.name} (${e.job_title})`
                })
            })

            employees = selectedEmployees
        }

        let filteredEmployeeList = []

        if (key === 1) {
            filteredEmployeeList = employees.filter(value => !value.disabled && !value.roles.includes(7))
        } else if (key === 2) {
            filteredEmployeeList = employees.filter(value => !value.disabled && value.roles.includes(7))
        } else if (key === 3) {
            filteredEmployeeList = employees.filter(value => value.disabled)
        }

        if (searchValue?.length > 0) {
            filteredEmployeeList = filteredEmployeeList.filter(e => (e.name.toLowerCase().indexOf(searchValue.toLowerCase()) > -1))
        }

        switch (sortType.value) {
            case 'NAZ':
                filteredEmployeeList = filteredEmployeeList.sort((a, b) => {
                    if (a.first_name > b.first_name) return 1
                    if (b.first_name > a.first_name) return -1
                    return 0
                })
                break;
            case 'NZA':
                filteredEmployeeList = filteredEmployeeList.sort((a, b) => {
                    if (a.first_name > b.first_name) return -1
                    if (b.first_name > a.first_name) return 1
                    return 0
                })
                break;
            case 'LAZ':
                filteredEmployeeList = filteredEmployeeList.sort((a, b) => {
                    if (a.last_name > b.last_name) return 1
                    if (b.last_name > a.last_name) return -1
                    return 0
                })
                break;
            case 'LZA':
                filteredEmployeeList = filteredEmployeeList.sort((a, b) => {
                    if (a.last_name > b.last_name) return -1
                    if (b.last_name > a.last_name) return 1
                    return 0;
                })
                break;
            case 'JAZ':
                filteredEmployeeList = filteredEmployeeList.sort((a, b) => {
                    if (a.job_title > b.job_title) return 1
                    if (b.job_title > a.job_title) return -1
                    return 0
                })
                break;
            case 'JZA':
                filteredEmployeeList = filteredEmployeeList.sort((a, b) => {
                    if (a.job_title > b.job_title) return -1
                    if (b.job_title > a.job_title) return 1
                    return 0;
                })
                break;
        }
        return filteredEmployeeList
    }

    const saveSettings = settings => {
        actions.saveEmployeesSettings(JSON.stringify(settings))
    }

    const handleShowPasswordChanger = () => {
        return (
            <OverlayTrigger placement="top"
                            onClick={() => setShowPassword(!showPassword)}
                            overlay={<Tooltip
                                id="reset_password_tooltip">{showPassword ? "Hide password" : "Show password"}</Tooltip>}>
                {showPassword ?
                    <p className="no-margin pointer"><FontAwesomeIcon icon={faEye}/></p>
                    :
                    <p className="no-margin pointer"><FontAwesomeIcon icon={faEyeSlash}/></p>}
            </OverlayTrigger>
        )
    }

    const renderDateTimeField = (employee, birthday, start_date, termination_date) => {
        return (
            <div>
                {key !== 2 && <Col md={4} style={{paddingRight: isMobile ? "0" : null}}>
                    <FormGroup>
                        <ControlLabel>Date of birth</ControlLabel>
                        <Datetime
                            dateFormat={defaultDateFormat}
                            timeFormat={null}
                            isClearable
                            value={employee.id === 0 ? employee[birthday] : employee[birthday] && moment(employee[birthday]).format(defaultDateFormat)}
                            name={birthday}
                            inputProps={{placeholder: "Date of birth"}}
                            closeOnSelect
                            onChange={e => handleDateChange(e, birthday)}
                        />
                    </FormGroup>
                </Col>}
                <Col md={key === 2 ? 6 : 4} style={{paddingRight: isMobile ? "0" : null}}>
                    <FormGroup>
                        <ControlLabel>Start Date</ControlLabel>
                        <Datetime
                            dateFormat={defaultDateFormat}
                            isClearable
                            utc
                            timeFormat={false}
                            closeOnSelect
                            value={employee[start_date] && moment(employee[start_date]).format(defaultDateFormat)}
                            name={start_date}
                            inputProps={{placeholder: "Start date"}}
                            onChange={e => handleDateChange(e, start_date)}
                        />
                    </FormGroup>
                </Col>
                <Col md={key === 2 ? 6 : 4} style={{paddingRight: isMobile ? "0" : null}}>
                    <FormGroup>
                        <ControlLabel>Termination Date</ControlLabel>
                        <Datetime
                            dateFormat={defaultDateFormat}
                            timeFormat={null}
                            isClearable
                            utc
                            value={employee[termination_date] && moment(employee[termination_date]).format(defaultDateFormat)}
                            name={termination_date}
                            inputProps={{placeholder: "Termination date"}}
                            closeOnSelect
                            onChange={e => handleDateChange(e, termination_date)}
                        />
                    </FormGroup>
                </Col>
            </div>
        )
    }

    const renderWorkDateInputs = (employee, attr_1, attr_2) => (
        <Row>
            <Col md={4}>
                <FormGroup>
                    <ControlLabel>Start Date</ControlLabel>
                    <Datetime
                        dateFormat={defaultDateFormat}
                        timeFormat={false}
                        value={employee[attr_1]}
                        name={attr_1}
                        inputProps={{placeholder: "Date of birth"}}
                        closeOnSelect
                        onChange={e => handleDateChange(e, attr_1)}
                    />
                </FormGroup>
            </Col>
            <Col md={4}>
                <FormGroup>
                    <ControlLabel>Termination Date</ControlLabel>
                    <Datetime
                        dateFormat={defaultDateFormat}
                        timeFormat={false}
                        value={employee[attr_2]}
                        name={attr_2}
                        inputProps={{placeholder: "Date of birth"}}
                        closeOnSelect
                        onChange={e => handleDateChange(e, attr_2)}
                    />
                </FormGroup>
            </Col>
        </Row>
    )


    const renderEmailField = (employee, attr) => {
        const onEmailBlur = (e) => {
            const email = trimAndCollapse(e.target.value)
            actions.updateEmployeeAttribute(employee.id, attr, email)
            if (email && (oldEmployee?.email_address !== email || employee.id === 0)) {
                actions.checkUniqueEmail(email, employee?.user?.id, true, res => {
                    if (!res.unique) {
                        setErrorMessage({...errorMessage, email_address: "Email address already exists"})
                    } else {
                        const { email_address, ...rest } = errorMessage;
                        setErrorMessage(rest);
                    }
                })
            }
        }
        return (
            <FormGroup bsStyle={errorMessage[attr] ? 'error' : null}>
                <ControlLabel>Email*</ControlLabel>
                <FormControl
                    type="text"
                    className="require-field"
                    placeholder="Email"
                    value={employee[attr] || ""}
                    onChange={e => {
                        actions.updateEmployeeAttribute(employee.id, attr, e.target.value)
                    }}
                    onBlur={onEmailBlur}
                />
                {errorMessage && errorMessage[attr] && <p className="error-message">{errorMessage[attr]}</p>}
            </FormGroup>
        )
    }

    const renderTextArea = (employee, attr) => {
        const name = humanize(attr)
        return (
            <FormGroup bsSize="sm" key={attr}>
                <ControlLabel>{name}</ControlLabel>
                <FormControl
                    componentClass="textarea"
                    placeholder={name}
                    value={employee[attr] || ""}
                    onChange={e =>
                        actions.updateEmployeeAttribute(
                            employee.id,
                            attr,
                            e.target.value
                        )}
                />
            </FormGroup>
        )
    }

    const renderCheckbox = (employee, attr) => (
        <FormGroup bsSize="sm">
            <Checkbox
                checked={employee[attr]}
                onChange={e => {
                    actions.updateEmployeeAttribute(
                        employee.id,
                        attr,
                        e.target.checked
                    )
                    if (!e.target.checked) {
                        actions.updateEmployeeAttribute(
                            employee.id,
                            'redirect_employee_id',
                            null
                        )
                    }
                    setEmployeesRedirectList([])
                }}
            >
                Disabled?
            </Checkbox>
        </FormGroup>
    )

    const renderUserAccountStatus = employee => {
        const isUserInactive = employee.is_user_disabled ? "Inactive" : "Active";

        if (employee?.user?.id) {
            return (
                <div>
                    User account status: <span
                    className={employee.is_user_disabled ? "colorRed" : "text-green"}>{isUserInactive}</span>
                </div>
            )
        }
    }

    const renderArboristCheckbox = (employee, attr) => (
        <FormGroup bsSize="sm">
            <Checkbox
                checked={employee[attr]}
                onChange={e =>
                    actions.updateEmployeeAttribute(
                        employee.id,
                        attr,
                        e.target.checked
                    )}
            >
                Check if {key === 2 ? 'subcontractor' : 'employee'} is a Sales Arborist
            </Checkbox>
        </FormGroup>
    )

    const renderManagerRoles = () => {
        return <>
            Roles*
            {roles && roles.map(
                r => {
                    const checkbox = (
                        <div key={r.id}>
                            <Checkbox
                                name="role_name"
                                onChange={e => {
                                    let roles = employeeRoles

                                    if (e.target.checked) {
                                        roles.push(r.id)
                                    }
                                    if (!e.target.checked) {
                                        roles = roles.filter(ur => ur !== r.id)
                                    }

                                    const user = {...employee.user, roles: roles}
                                    actions.updateEmployeeAttribute(employee.id, "user", user)
                                }}
                                inline
                                checked={employeeRoles.includes(r.id)}
                            >
                                {" "}
                                <OverlayTrigger placement="right" overlay={<Tooltip>
                                    <div>{rolesDescriptions[r.code]}</div>
                                </Tooltip>}>
                                    <div>
                                        {r.code}
                                    </div>
                                </OverlayTrigger>

                            </Checkbox></div>);
                    return checkbox;
                }
            )}
        </>
    }

    const renderImageDropZone = () => {
        return <>
            <FormGroup>
                <ControlLabel>
                    Image
                </ControlLabel>
                <Dropzone
                    onDrop={file => actions.uploadImages(file, employee.user.id, img => {
                        img.primary = false
                        const oldUser = {...oldEmployee.user, images: employee?.user?.images.concat(img)}
                        employee = {
                            ...employee,
                            user: {
                                ...employee.user,
                                images: employee?.user?.images.concat(img),
                                password: "",
                                password_confirmation: ""
                            }
                        }
                        actions.updateEmployeeAttribute(employee.id, "user", employee.user)
                        actions.saveUserInfo(oldUser)
                    })}
                    className="dropzone pointer small">
                    <p>Drop a file here or click to select a file to upload.</p>
                </Dropzone>
                <Col md={12}>
                    {!employee?.user?.images || employee?.user?.images?.length === 0 ? "No photos found. Please upload some." : ""}
                    {employee?.user?.images && employee?.user?.images?.map(i => <Attachment key={i.id}
                                                                                            reloadData={() => actions.fetchEmployeeList()}
                                                                                            image={i}
                                                                                            allowRemove={true}
                                                                                            setAsMain={() =>
                                                                                                actions.setAsPrimary(i.id, () => {
                                                                                                    const oldPrimary = employee.user.images.find(image => image.primary)
                                                                                                    if (oldPrimary) oldPrimary.primary = false
                                                                                                    employee.user.images.find(image => image.id === i.id).primary = true
                                                                                                    actions.fetchEmployeeList()
                                                                                                })}
                                                                                            deleteImage={imageId => {
                                                                                                const index = employee.user.images.findIndex(image => image.id === imageId)
                                                                                                const oldUser = oldEmployee.user
                                                                                                employee = {
                                                                                                    ...employee,
                                                                                                    user: {
                                                                                                        ...employee.user,
                                                                                                        password: "",
                                                                                                        password_confirmation: ""
                                                                                                    }
                                                                                                }
                                                                                                employee.user.images.splice(index, 1)
                                                                                                oldUser.images.splice(index, 1)
                                                                                                actions.updateEmployeeAttribute(employee.id, "user", employee.user)
                                                                                                actions.saveUserInfo(oldUser)
                                                                                            }}
                    />)}
                </Col>
            </FormGroup>
        </>
    }

    const renderPassword = () => {
        return (
            <Row className="generate-password require-field">
                <Col md={8} xs={12}>
                    <Row className="align-text-end" style={{flexDirection: isMobile ? "column" : "row"}}>
                        <Col xs={isMobile ? 12 : 6}>
                            <FormGroup>
                                <ControlLabel>
                                    New Password*
                                </ControlLabel>
                                <InputGroup>
                                    <FormControl
                                        name="password"
                                        type={showPassword ? "text" : "password"}
                                        autoComplete="new-password"
                                        placeholder="password"
                                        value={employee.user?.password && employee.user?.password}
                                        onChange={e => {
                                            const user = {...employee.user, password: e.target.value?.replace(/ /g, '')}
                                            actions.updateEmployeeAttribute(employee.id, "user", user)
                                        }}
                                    />
                                    <InputGroupAddon>
                                        {handleShowPasswordChanger()}
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        <Col xs={isMobile ? 12 : 6}>
                            <FormGroup>
                                <ControlLabel>
                                    Password Confirmation*
                                </ControlLabel>
                                <InputGroup>
                                    <FormControl
                                        name="password_confirmation"
                                        type={showPassword ? "text" : "password"}
                                        placeholder="password confirmation"
                                        value={employee.user?.password_confirmation}
                                        onChange={e => {
                                            const user = {
                                                ...employee.user,
                                                password_confirmation: e.target.value?.replace(/ /g, '')
                                            }
                                            actions.updateEmployeeAttribute(employee.id, "user", user)
                                        }}
                                    />
                                    <InputGroupAddon>
                                        {handleShowPasswordChanger()}
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        </Col>
                        {errorMessage?.password?.length > 0 &&
                            <p className="error-message">{errorMessage?.password}</p>}
                    </Row>
                </Col>
                <Col md={4} xs={12} className="bottom15 text-center">
                    <Button bsStyle="success responsive-button" style={{width: "clamp(10px, 100%, 200px)"}}
                            onClick={() => actions.generatePassword(res => {
                                const user = {
                                    ...employee.user,
                                    password: res.password,
                                    password_confirmation: res.password
                                }
                                actions.updateEmployeeAttribute(employee.id, "user", user)
                            })}>
                        Generate Password
                    </Button>
                </Col>
            </Row>
        )
    }

    const renderColor = () => {
        return (
            <>
                <div className="user_color">
                    <div
                        style={{backgroundColor: employee?.color}}
                        className={`color-picker pointer img-circle color-circle`}
                        onClick={() => setShowPicker(!showPicker)}/>
                    <span>
                        User Color
                    </span>
                </div>
                <div ref={pickerRef}>
                    {showPicker && <SketchPicker
                        color={employee?.color}
                        className="picker"
                        onChangeComplete={e => {
                            if (e.hex) {
                                actions.updateEmployeeAttribute(employee.id, "color", e.hex)
                            }
                        }}
                    />}
                </div>
                {errorMessage && errorMessage.color && <p className="error-color-message">{errorMessage.color}</p>}
            </>
        )
    }

    const renderEmployeeEditor = employee => (
        <form onSubmit={e => submitForm(e, employee.id)} id="employee-page" ref={formRef}>
            <Row className="full-width">
                <Col xs={12}>
                    {key === 2 && <Row>
                        <Col xs={12}>
                            {renderTextField(employee, "company_name")}
                        </Col>
                    </Row>}
                    <Row>
                        <Col xs={6}>
                            {renderTextField(employee, "first_name", true)}
                        </Col>

                        <Col xs={6}>
                            {renderTextField(employee, "last_name", true)}
                        </Col>

                    </Row>

                    <Row>
                        <Col xs={6}>
                            {renderPhoneField(employee, "phone_number")}
                        </Col>
                        {!isMobile && <Col xs={6}>
                            {renderEmailField(employee, "email_address")}
                        </Col>}
                    </Row>
                    {isMobile && <Row>
                        <Col xs={12}>
                            {renderEmailField(employee, "email_address")}
                        </Col>
                    </Row>}
                    <Row>
                        <Col xs={isMobile ? 12 : 6}>
                            {renderTextField(employee, "job_title", true)}
                        </Col>
                        <Col xs={12} md={isMobile ? 12 : 6}
                             className={!smMobile ? "no-padding" : smMobile && "no-left-padding"}>
                            {renderDateTimeField(employee, "birthday", "start_date", "termination_date")}
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={isMobile ? 8 : 4}>
                            {renderArboristCheckbox(employee, "is_sales_arborist")}
                            {renderCheckbox(employee, "disabled")}
                            {employeesRedirectList && employeesRedirectList.length > 0 &&
                                <p className='text-danger'>The user you want to disable is assigned to receive
                                    redirected emails and must be unassigned first
                                    from: {employeesRedirectList.join(', ')}</p>}
                            {employee.disabled && <FormGroup bsSize="sm" key={'redirect_employee_id'}>
                                <ControlLabel>Emails redirect to</ControlLabel>
                                <Select className="Select" classNamePrefix="select"
                                        options={employeeList.filter(e => !e.disabled && e.id !== employee.id).map(e => ({
                                            label: e.name,
                                            value: e.id
                                        }))}
                                        isClearable
                                        value={select(employeeList.filter(e => !e.disabled && e.id !== employee.id).map(e => ({
                                            label: e.name,
                                            value: e.id
                                        })), employee.redirect_employee_id)}
                                        onChange={e => actions.updateEmployeeAttribute(
                                            employee.id,
                                            'redirect_employee_id',
                                            e ? e.value : e
                                        )}/>
                            </FormGroup>

                            }
                        </Col>
                        <Col xs={isMobile ? 4 : 2}>
                            {employee.id !== 0 && renderColor()}
                        </Col>
                        {!isExistingEmployeeWithoutUser && <Col xs={isMobile ? 12 : 6}>
                            {renderPassword()}
                        </Col>}
                    </Row>
                    <Row>
                        {employee.is_sales_arborist === true ?
                            <Col xs={isMobile ? 12 : 6}>
                                For Export as QuickBooks Sales Rep
                                {renderTextField(employee, "initials")}
                            </Col> : <Col xs={isMobile ? 12 : 6}/>}
                        {!isExistingEmployeeWithoutUser && <Col xs={isMobile ? 12 : 6}>
                            <Row className="full-width">
                                <Col xs={12}>Signature</Col>
                            </Row>
                            <Row className="full-width margin-5">
                                <Col xs={4}>
                                    <Button bsStyle="success responsive-button" onClick={show}>
                                        Show signature modal
                                    </Button>
                                </Col>
                            </Row>
                        </Col>}
                    </Row>
                    {isExistingEmployeeWithoutUser
                        ? <Row>
                            <Col xs={12}>
                                <div className="alert alert-warning">
                                    This employee does not have a linked user account. Roles, images and other user
                                    account settings are unavailable.
                                </div>
                            </Col>
                        </Row>
                        : <Row>
                            <Col xs={6}>
                                {renderManagerRoles()}
                            </Col>
                            <Col xs={6}>
                                {employee.id !== 0 && renderImageDropZone()}
                                {renderUserAccountStatus(employee)}
                            </Col>
                        </Row>}
                </Col>
            </Row>
            <Row>
                <Col xs={12} style={isMobile ? {marginTop: "15px"} : {}}>
                    <Row>
                        <Col xs={12}>
                            <Row>
                                <Col xs={4}>
                                    <Button
                                        disabled={!(key === 3 && employee.disabled)}
                                        bsStyle="danger"
                                        className="responsive-button"
                                        style={{width: isMobile ? "155px" : "clamp(10px, 33vw, 165px)"}}
                                        onClick={e => (key === 3 && employee.disabled) && deleteEmployee(employee.id)}
                                    >
                                        Delete {key === 2 ? 'subcontractor' : 'employee'}
                                    </Button>
                                </Col>
                                <Col xs={8}>
                                    {employee.id === 0
                                        ? <Button
                                            bsStyle="info"
                                            className="pull-right"
                                            type="submit"
                                            disabled={loading ||
                                                !employee?.first_name ||
                                                !employee?.last_name ||
                                                !employee?.email_address ||
                                                !employee?.job_title ||
                                                !employee?.user?.password ||
                                                !employee?.user?.password_confirmation ||
                                                (key !== 2 && employeeRoles.length === 0) ||
                                                (employee?.user?.password !== employee?.user?.password_confirmation)
                                            }
                                        >
                                            {loading ?
                                                <span><MDSpinner
                                                    size={20}/> Loading...</span> : `Save New ${key === 2 ? 'subcontractor' : 'employee'}`}
                                        </Button>
                                        :
                                        <div className="success_buttons">
                                            {!isExistingEmployeeWithoutUser && <div>
                                                <Button
                                                    bsStyle="success"
                                                    style={{width: "clamp(10px, 57vw, 200px)"}}
                                                    className="reset_password_button responsive-button"
                                                    onClick={() => {
                                                        actions.requestPasswordChange(employee?.user?.id)
                                                    }}
                                                    disabled={employee.disabled}
                                                >
                                                    Request password change
                                                </Button>
                                            </div>}
                                            <div className="d-flex"
                                                 style={isMobile ? {flexDirection: "column", gap: "10px"} : {}}>
                                                {!isExistingEmployeeWithoutUser && <Button
                                                    bsStyle="success"
                                                    style={{width: isMobile ? "150px" : "clamp(10px, 27vw, 120px)"}}
                                                    className={`${isMobile ? "" : "mr-10"} responsive-button`}
                                                    onClick={() => {
                                                        actions.requestPasswordChange(employee?.user?.id, 'invitation')
                                                    }}
                                                    disabled={employee.disabled}
                                                >
                                                    Send Invitation
                                                </Button>}
                                                <Button
                                                    disabled={loading || Object.keys(errorMessage).length > 0 || (!isExistingEmployeeWithoutUser && employeeRoles.length === 0)}
                                                    bsStyle="success"
                                                    style={{width: isMobile ? "150px" : "clamp(10px, 27vw, 120px)"}}
                                                    className="responsive-button"
                                                    type="submit"
                                                >

                                                    {loading ?
                                                        <span><MDSpinner size={20}/> Loading...</span> : 'Save Changes'}
                                                </Button>
                                            </div>
                                        </div>
                                    }
                                </Col>
                            </Row>


                        </Col>
                    </Row>
                    <Row className="mt27">
                        <Col xs={12}>
                            <p>
                                {`Last updated ${employee.modified_at ? moment(employee.modified_at).format("llll") :
                                    <i>Unknown</i>} by ${employee.modified_by}`}
                            </p>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </form>
    )

    useEffect(() => refreshEmployeeList(), [])
    useEffect(() => {
        if (employee?.disabled) {
            actions.checkIfHaveRedirects(employee.id, res => {
                setEmployeesRedirectList(res.employees_list)
            })
        }
    }, [employee])

    const refreshSubscriptionSettings = () => actions.loadEmployeesSettings(res => {
        const settings = JSON.parse(res.settings)
        setSettings(settings)
        setSubscriptionSettings(res.subscription_settings)
        setRoles(res.roles)
        if (settings) {
            settings.sort_type && setSortType(employeesSortOptions.find(e => e.value === settings.sort_type))
            settings.key && setKey(settings.key)
        }
        setLoading(false)
    })

    const closeSubscriptionModal = () => {
        setShowSubscriptionModal(null)
        setLoading(false)
    }

    useEffect(refreshSubscriptionSettings, [])

    return (
        <Grid fluid>
            <Helmet title="Employees"/>
            <PageHeader
                pageName="Employees"
                pageDetail="Manage Employees."
            />
            <Row>
                <Col xs={12}>
                    <Button onClick={e => refreshEmployeeList()} bsStyle="success">
                        Refresh employees
                    </Button>
                    {" "}
                    <Button onClick={e => addNewEmployee()} bsStyle="info">
                        New {key === 2 ? 'subcontractor' : 'employee'}
                    </Button>
                </Col>
                {key === 2 && <Col xs={12}>
                    <ColorCheckbox value={showCompanyName} label='Show Company Name'
                                   onChange={() => setShowCompanyName(prev => !prev)}/>
                </Col>}
            </Row>
            <p>&nbsp;</p>

            <Row>
                <Col xs={12} md={3}>
                    <Tabs defaultActiveKey={1} animation={false} activeKey={key}
                          onSelect={k => {
                              saveSettings({...settings, key: k})
                              setKey(k)
                              setSettings({...settings, key: k})
                              refreshEmployeeList()
                          }}>
                        <Tab eventKey={1} title="Active"></Tab>
                        <Tab eventKey={2} title="Subcontractors"></Tab>
                        <Tab eventKey={3} title="Archived"></Tab>
                    </Tabs>
                    <form>
                        <FormGroup className="mt5 bottom5">
                            <ControlLabel>Filter</ControlLabel>
                            <FormControl
                                type="text"
                                placeholder="Filter employees"
                                value={searchValue}
                                onChange={e => changeFilterText(e.target.value)}
                            />
                        </FormGroup>
                        <FormGroup>
                            <ControlLabel>Sort</ControlLabel>
                            <Select className="Select"
                                    classNamePrefix="select"
                                    defaultValue={employeesSortOptions[0]}
                                    options={employeesSortOptions}
                                    isSearchable={false}
                                    value={sortType}
                                    onChange={newValue => {
                                        setSortType(newValue)
                                        saveSettings({...settings, sort_type: newValue.value})
                                        setSettings({...settings, sort_type: newValue.value})
                                    }}
                            />
                        </FormGroup>
                    </form>
                    <div style={{height: isMobile ? employee ? "250px" : "560px" : "560px", overflowY: "scroll"}}>
                        <Nav
                            bsStyle="pills"
                            stacked
                            activeKey={editingEmployeeId}
                            onSelect={editEmployee}
                        >
                            {filterAndSortEmployeeList(employeeList).map(p => (
                                    <NavItem key={p.id} eventKey={p.id}>
                                        <div className='vertical-align'>
                                            <>{p.name}</>
                                            {/*<span className='font11 ml-7'>{`(${p?.job_title})`}</span>*/}
                                        </div>
                                    </NavItem>
                                )
                            )}

                            {filterText.length > 0 &&
                                filterAndSortEmployeeList(employeeList).length === 0 &&
                                <p>No Employees Match Your Filter</p>}
                        </Nav>
                    </div>
                </Col>
                <Col xs={12} md={9}>
                    {employee && renderEmployeeEditor(employee)}
                </Col>
            </Row>
            <SignatureModal
                animation={false}
                show={signatureModal.show}
                onHide={() => {
                    setSignatureModal({show: false})
                }}
                onSave={(signature) => {
                    actions.updateEmployeeAttribute(
                        employee.id,
                        'signature',
                        signature
                    )
                    setTimeout(() => {
                        formRef.current?.dispatchEvent(new Event('submit', {cancelable: true, bubbles: true}));
                        setSignatureModal(prev => ({...prev, show: false}))
                    }, 200);
                }}
                userName={employee?.first_name + " " + employee?.last_name}
                signature={signatureModal.text}
            />
            {showSubscriptionModal && <Modal
                animation={false}
                show={showSubscriptionModal}
                onHide={closeSubscriptionModal}
                className={"heightAuto maxHeight90 modalLeadsFilterBody fontIOS"}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update subscription</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure to increase the number of subscriptions? There will be an additional cost of <Dollars
                    amount={subscriptionSettings.user_price}/> per
                    month.
                </Modal.Body>
                <Modal.Footer>
                    <Row>
                        <Col md={6} className="text-left">
                        </Col>
                        <Col md={6}>
                            <button type="button" onClick={closeSubscriptionModal}
                                    className="btn btn-default"
                                    data-dismiss="modal">Cancel
                            </button>
                            <button type="button"
                                    onClick={() => {
                                        setLoading(true)
                                        showSubscriptionModal.callback(true)
                                        setShowSubscriptionModal(null)
                                    }}
                                    className="btn btn-success">Update
                            </button>
                        </Col>
                    </Row>
                </Modal.Footer>
            </Modal>}
        </Grid>
    )
}

const mapStateToProps = state => {
    return {
        employeeList: state.employees.employeeList.filter(
            p =>
                p.name
                    .toLowerCase()
                    .indexOf(state.employeesCrud.filterText.toLowerCase()) !== -1
        ),
        employeeListLastUpdated: state.employees.employeeListLastUpdated,
        filterText: state.employeesCrud.filterText,
        editingEmployeeId: state.employeesCrud.editingEmployeeId,
        employee: state.employees.employees[
            `employee_${state.employeesCrud.editingEmployeeId}`
            ],
        auth: state.auth
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators(Actions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EmployeesPage)
